<app-sidenav [isMenuOpen]="isMenuOpen" [isHandset]="(isHandset$ | async) || false" #sidenav>
  <div sidenav data-testid="nav-bar">
    <div class="nav-list-content grey-thm">
      <div class="menu-content">
        <div class="logo-display">
          @if (isMenuOpen) {
            <div class="logo-maxi">
              <img alt="image" src="https://static.soregies.fr/logos/Groupe+Sore%CC%81gies/Logos+Groupe+Soregies/Logo+Groupe+Soregies/Logo+Groupe+Soregies.png"/>
            </div>
          }
          @if (!isMenuOpen || (isMenuOpen && (isHandset$ | async))) {
            <div class="logo-mini"></div>
          }
        </div>
        <app-menu-navigation [isMenuOpen]="isMenuOpen"></app-menu-navigation>
      </div>
    </div>
  </div>

  <div sidenav-content>
    <app-header [isMenuOpen]="isMenuOpen" class="header" [sidenav]="sidenav"></app-header>
    <app-alert></app-alert>
    <router-outlet></router-outlet>
  </div>
</app-sidenav>
